<form [formGroup]="vehicleGroup" (ngSubmit)="save()">
    <div class="vehicle-fields-wrapper">
        <div class="header">
            <button *ngIf="search && vehicleType !== VehicleType.TradeIn" class="vehicle-search-button" type="button" (click)="openSearch()">
                <span>Search for a Vehicle</span>
                <mat-icon>search</mat-icon>
            </button>
        </div>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>VIN</mat-label>
                <input matInput formControlName="vin" maxlength="18" minlength="5" />
                <mat-error>VIN is required</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="vehicleType !== VehicleType.TradeIn" class="col" appearance="fill">
                <mat-label>Stock ID</mat-label>
                <input matInput formControlName="stockNumber" />
                <mat-error>Stock ID is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>{{ vehicleType === VehicleType.Vehicle ? 'Price' : 'Value' }}</mat-label>
                <input matInput type="number" formControlName="priceInternet" />
                <mat-error>{{ vehicleType === VehicleType.Vehicle ? 'Price' : 'Value' }} is required</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="vehicleType !== VehicleType.TradeIn" class="col" appearance="fill">
                <mat-label>New/CPO/Used</mat-label>
                <mat-select formControlName="status">
                    <mat-option *ngFor="let status of carStatus" [value]="status.value">{{ status.displayValue }}</mat-option>
                </mat-select>
                <mat-error>Status is required</mat-error>
            </mat-form-field>
            <mat-form-field class="col" appearance="fill">
                <mat-label>Mileage</mat-label>
                <input matInput type="number" formControlName="mileage" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>Year</mat-label>
                <input matInput maxlength="4" minlength="4" formControlName="year" />
            </mat-form-field>
            <mat-form-field class="col" appearance="fill">
                <mat-label>Make</mat-label>
                <input matInput formControlName="make" />
            </mat-form-field>
            <mat-form-field class="col" appearance="fill">
                <mat-label>Model</mat-label>
                <input matInput formControlName="model" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>Trim</mat-label>
                <input matInput formControlName="trim" />
            </mat-form-field>
            <mat-form-field class="col" appearance="fill">
                <mat-label>Body Style</mat-label>
                <input matInput formControlName="bodyStyle" />
            </mat-form-field>
        </div>
        <div *ngIf="type === 'jacket'" class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>Ext. Color</mat-label>
                <input matInput formControlName="extColor" />
            </mat-form-field>
            <mat-form-field class="col" appearance="fill">
                <mat-label>Int. Color</mat-label>
                <input matInput formControlName="intColor" />
            </mat-form-field>
        </div>
    </div>

    <ng-container>
        <div class="buttons">
            <button mat-button (click)="closeModal()" type="button" class="secondary">Cancel</button>
            <button mat-button type="submit" class="primary">Save</button>
        </div>
    </ng-container>
</form>
